import { FC } from 'react';
import { useOutletContext } from 'react-router';
import { useTranslation } from 'react-i18next';
import s from '../../Projects.module.scss';
import { Modal } from 'components/common/Modal/Modal';
import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';
import { ProjectList } from '../ProjectList/ProjectList';

export const ProjectsWindow: FC = () => {
  const { t } = useTranslation();
  const { closeRouteModal } = useOutletContext<ModalNavigationContext>();

  return (
    <Modal title={t('navigationPanel.projects')} onClose={closeRouteModal}>
      <div className={s['window-content']}>
        <ProjectList />
      </div>
    </Modal>
  );
};
